import { createContext, useContext } from "react";

// Identity of the user a workspace pane belongs to. Pane-level listeners that react to
// auth-state changes MUST no-op when the event's current user is not their owner: the
// switch event fires synchronously while the outgoing pane is still visible+subscribed,
// and without this guard the outgoing tree would clear its own state and fetch the
// incoming user's data into the workspace that is about to freeze.
//
// Default '' = "not inside a workspace pane" — consumers treat that as owner-always-matches
// (legacy single-tree behavior).
export const WorkspaceOwnerContext = createContext("");

export function useWorkspaceOwnerId() {
  return useContext(WorkspaceOwnerContext);
}
